import { Link, useParams } from 'react-router-dom';
import { Breadcrumbs } from '@/components/site/Breadcrumbs';
import { Prose } from '@/components/site/Prose';
import { SiteMeta } from '@/components/site/SiteMeta';
import { findCase } from '@/content/cases';
import { trialHref } from '@/content/plans';
import { NotFoundPage } from '@/pages/site/seo/NotFoundPage';

function formatDate(iso: string): string {
  const [ano, mes, dia] = iso.split('-');
  return `${dia}/${mes}/${ano}`;
}

export function CasePage() {
  const { slug = '' } = useParams();
  const item = findCase(slug);
  if (!item) return <NotFoundPage />;

  return (
    <>
      <SiteMeta title={`${item.title} | Operax`} description={item.description} path={`/casos/${item.slug}`} />

      <section className="page-hero">
        <div className="hero-grid-bg" />
        <div className="shell page-hero-in rev">
          <Breadcrumbs
            items={[
              { name: 'Início', path: '/' },
              { name: item.company },
            ]}
          />
          <div className="eyebrow">Caso de cliente</div>
          <h1>{item.title}</h1>
          <p className="seo-meta">
            Publicado em <time dateTime={item.published}>{formatDate(item.published)}</time> · Depoimento autorizado
            pelo cliente
          </p>
        </div>
      </section>

      <section className="pad">
        <article className="shell seo-article">
          <p className="seo-summary">
            <strong>Resumo.</strong> {item.summary}
          </p>

          {item.metrics.length > 0 && (
            <ul className="case-metrics">
              {item.metrics.map((m) => (
                <li key={m.value}>
                  <span className="n">{m.value}</span>
                  <span className="l">{m.label}</span>
                </li>
              ))}
            </ul>
          )}

          <Prose markdown={item.markdown} />

          <h2>O que diz quem usa</h2>
          <figure className="case-quote">
            <blockquote>
              {item.quote.map((p) => (
                <p key={p.slice(0, 24)}>{p}</p>
              ))}
            </blockquote>
            <figcaption>
              <strong>{item.author.name}</strong>, {item.author.role}
            </figcaption>
          </figure>

          {item.method && (
            <aside className="seo-aside">
              <h2>Como medimos</h2>
              <p>{item.method}</p>
            </aside>
          )}

          <div className="hero-cta" style={{ marginTop: 36 }}>
            <a className="btn btn-primary" href={trialHref()}>
              Assinar a Operax
            </a>
            <Link className="btn btn-ghost" to="/contato">
              Falar com vendas
            </Link>
          </div>
        </article>
      </section>
    </>
  );
}
